import React, { Component } from 'react';
import { Divider, Icon, Affix } from 'antd';
import { Link } from 'react-router-dom';
import { ROUTES, WINDOW } from 'utils/utils';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

export default class AfspHeader extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const
        { win } = this.props,
        { displayType } = win,
        { HOME } = ROUTES,
        { DESKTOP_MENU, MOBILE_MENU } = WINDOW;

        switch(displayType) {
            case DESKTOP_MENU:
                return (
                        <div
                            style={{
                                position: 'fixed',
                                bottom: '0px',
                                background: 'rgb(240, 242, 245)',
                                padding: '15px 20px 15px 20px',
                                width: (win.width) + 'px'
                            }}
                        >
                            <div>
                                <div style={{ textAlign: 'center', fontSize: '12px' }}>
                                    <a href='https://www.tsa.gov/' target='_blank'>{'Transportation Security Administration'}</a>
                                    <Divider type="vertical" />
                                    <a href='https://www.tsa.gov/privacy-policy' target='_blank'>{'Terms of Use / Privacy Policy'}</a>
                                    <Divider type="vertical" />
                                    <Link to={HOME.PRA}>{'Paperwork Reduction Act'}</Link>
                                    <Divider type="vertical" />
                                    <Link to={HOME.PAS}>{'Privacy Act Statement'}</Link>
                                </div>

                                <div style={{ marginTop: '15px', fontSize: '12px' }}>
                                    <div>
                                        {'Some links on this page may require a browser plug-in, available here:'} &nbsp;&nbsp;
                                        <Icon type="file-pdf" />&nbsp;
                                        <a href={ssCommonUtils.setEnvPrefix("/home/warning?url=") + encodeURIComponent('http://get.adobe.com/reader/')} target='_blank'>{'Adobe Acrobat (PDF)'}</a>
                                    </div>

                                    <div>
                                        {' This online portal may be unavailable during following scheduled maintenance periods:'}&nbsp;
                                        <i> {'Tuesdays and Thursdays from 3:00 – 6:00 AM (03:00 – 06:00) Eastern Time'} </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                )
            case MOBILE_MENU:
                return (
                    <div>
                    </div>
                )
        }
    }
}
